/**
 * This class will extend sumo.maps.GoogleMapControl class instance
 * and will add specific  functionalities related to the offender Address Map
 * @class GoogleMapControl
 * 
*/
(function(map){
    // 
     /**
     * Initialize layer
     * @name mapInit
     * @function 
     * @memberof GoogleMapControl
     */
    map.prototype.mapInit = function (options) {
        "use strict";
        var lSystemPreferences = getUserPreferences(10),
            lDisplayType = 'roadmap';
    
        if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
            lDisplayType = lSystemPreferences['MapDisplayType'].Value;
        }
        var lLayerOptions = Object.assign({
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 1000000,
        },options);
        var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
            lIsInformatics = false;
        if (!isNullOrUndefined(lEnrollee)) {
            lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
        }
        if(lIsInformatics){
            lLayerOptions['markerImageSize']= { 'width': 70, 'height': 70 };
        }
        this.layerAdd('address', lLayerOptions);
    }
    /**
     * Create data source layer 'address' and displaying icon home,work & other
     * @name setAddressMarker
     * @function
     * @param {string} elementId - The HTML element Id
     * @param {string} aLatitude - a Latitude value in String format
     * @param {string} aLongitude - a Longitude  value in String format
    */
    map.prototype.setAddressMarker = function (elementId,aLatitude, aLongitude) {
        var lMarker = '',
            lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
            lIsInformatics = false;

        if (!isNullOrUndefined(lEnrollee)) {
            lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
        }
        this.setCenter(aLatitude, aLongitude);
        this.zoom(17);
        var iconData = {},name= "261",valueId = document.getElementById(elementId)!= null? document.getElementById(elementId).value : 0 ;
        switch (parseInt(valueId, 10)) {
            case 1:
                lMarker = 'Images/Maps/home.png';
                name = "Address Home";
                break;
            case 2:
                lMarker = 'Images/Maps/work.png';
                name = "Address Work";
                break;
            case 6:
                lMarker = 'Images/Maps/other.png';
                name = "Address Transient";
                break;
            default:
                lMarker = 'Images/Maps/other.png';
                name = "Address Other";
                break;
        }
        var anchor = lIsInformatics == true? { 'x': 0, 'y': 35 }: { 'x': 15, 'y': 15 };
        if(lIsInformatics){
            veritracks.mapping.iconGenerator.clear();    
            var IconId = IconHelper.getIconIdByName(name);
            if(!isNullOrUndefined(mEnrolleesIcon['icons'][IconId]['IconValue'])){
                lMarker = veritracks.mapping.iconGenerator.generateMapMarker(mEnrolleesIcon.icons[IconId]['IconValue'])
            }
        }
        iconData =  {
            'data': null,
            'latitude': aLatitude,
            'longitude': aLongitude,
            'anchor': anchor,
            'doHover': false,
            'iconUri': lMarker,
            'identity': new Date(),
        };
        this.layerSetDataSource('address', [iconData]);
    
    };
     /**
     * Check uOffenderGeocodeCheck , clear data source layer & offenders LatLng on html elements
     * @name mustGeocodeInit
     * @function
    */
    map.prototype.mustGeocodeInit = function () {
        var lBypassGeocode = $('#uOffenderGeocodeCheck').is(':checked');
        if (!lBypassGeocode){
            $('.PopupWindow .SaveButton').hide();
            $('#uVeritracksModal .SaveButton').hide();
        }
            
        this.layerSetDataSource('address', []);
        $('#uOffenderAddressLatitudeEdit').val(0);
        $('#uOffenderAddressLongitudeEdit').val(0);
    }
})(sumo.maps.GoogleMapControl);